import { useI18n } from '@/context/I18nContext';
import { LogIn, Target, LogOut } from 'lucide-react';

import type { CornerMetric } from './CornerMetricTabs';

export type CornerPhase = 'entrance' | 'apex' | 'exit';

interface CornerPhaseTabsProps {
  activePhase: CornerPhase;
  onPhaseChange: (phase: CornerPhase) => void;
  activeMetric?: CornerMetric;
}

export function CornerPhaseTabs({ activePhase, onPhaseChange, activeMetric = 'speed' }: CornerPhaseTabsProps) {
  const { t } = useI18n();

  if (activeMetric === 'duration') {
    return null;
  }

  const isRpm = activeMetric === 'rpm';
  const tabs: Array<{ id: CornerPhase; label: string; icon: typeof LogIn; color: string }> = [
    { id: 'entrance', label: isRpm ? t('corner.entranceRpm') : t('corner.entranceSpeed'), icon: LogIn, color: 'text-green' },
    { id: 'apex', label: isRpm ? t('corner.apexRpm') : t('corner.apexSpeed'), icon: Target, color: 'text-red' },
    { id: 'exit', label: isRpm ? t('corner.exitRpm') : t('corner.exitSpeed'), icon: LogOut, color: 'text-purple' },
  ];

  return (
    <div className="flex items-center gap-1 p-1 bg-bg-surface border border-border-subtle rounded-xl">
      {tabs.map((tab) => {
        const isActive = activePhase === tab.id;
        const Icon = tab.icon;

        return (
          <button
            key={tab.id}
            onClick={() => onPhaseChange(tab.id)}
            className={`
              flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-xs font-semibold transition-all duration-150 cursor-pointer
              ${isActive
                ? 'bg-accent/15 text-accent shadow-sm border border-accent/30'
                : 'text-text-secondary hover:text-text-primary hover:bg-bg-hover'
              }
            `}
          >
            <Icon size={14} className={isActive ? tab.color : 'text-text-muted'} />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
